import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import qandaAPI from "api/qandaAPI";

const getQA = createAsyncThunk("GET_QA", async (_arg, { rejectWithValue }) => {
  try {
    const res = await qandaAPI.getQA(_arg);
    if( res.sorrypage == '0') {
      return {
        qanda: null,
        isInLine: true
      }
    }
    return {
      qanda: res.data.qanda,
      isInLine: res.data.isInLine
    }
  } catch (error) {
    return rejectWithValue(error);
  }
});

const initialState = {
  data: null,
  category: [],
  reference: [],
  isInLine: false
};

const qaSlice = createSlice({
  name: "qa",
  initialState,
  extraReducers: {
    [getQA.fulfilled]: (state, action) => {
      state.data = action.payload.qanda?.data;
      state.category = action.payload.qanda?.category;
      state.reference = action.payload.qanda?.reference;
      state.isInLine = action.payload.isInLine;
    },
  },
});

const { reducer } = qaSlice;
export { getQA };
export default reducer;
